// Place holder for new tokens

/** Colour brand blue for coworker facing tools  */
export const colourBrandBlueDark = '#003f73'

/** Colour blue for large headings in cowoker-mvp */
export const colourBlueHeading = '#0058A3' // used in Figma for large headings
